module.exports = __webpack_public_path__ + "assets/appnexus.10bb4c5c.svg";